/**
 * Обработчик Google ReCaptcha для защиты от DDoS
 */

(function() {
    'use strict';

    var captchaWidgetId = null;
    var onVerifyCallback = null;

    /**
     * Показывает модальное окно капчи
     */
    function showCaptcha(callback) {
        onVerifyCallback = callback;
        var modal = document.getElementById('captcha-modal');
        if (!modal) return;

        modal.classList.add('active');
        document.body.style.overflow = 'hidden';

        // Инициализируем капчу если еще не сделано
        initCaptcha();
    }

    /**
     * Скрывает модальное окно капчи
     */
    function hideCaptcha() {
        var modal = document.getElementById('captcha-modal');
        if (!modal) return;

        modal.classList.remove('active');
        document.body.style.overflow = '';
        
        var errorDiv = document.getElementById('captcha-error');
        if (errorDiv) errorDiv.style.display = 'none';
        
        if (typeof grecaptcha !== 'undefined' && captchaWidgetId !== null) {
            grecaptcha.reset(captchaWidgetId);
        }
    }

    /**
     * Инициализирует виджет ReCaptcha
     */
    function initCaptcha() {
        if (typeof grecaptcha === 'undefined') {
            // Загружаем скрипт Google ReCaptcha если его еще нет
            var script = document.createElement('script');
            script.src = 'https://www.google.com/recaptcha/api.js?render=explicit';
            script.async = true;
            script.defer = true;
            script.onload = renderWidget;
            document.head.appendChild(script);
        } else {
            renderWidget();
        }
    }

    /**
     * Отрисовывает виджет
     */
    function renderWidget() {
        if (captchaWidgetId !== null) return;

        captchaWidgetId = grecaptcha.render('recaptcha-container', {
            'sitekey': window.RECAPTCHA_SITE_KEY,
            'callback': handleCaptchaSuccess,
            'expired-callback': handleCaptchaExpired,
            'error-callback': handleCaptchaError
        });
    }

    /**
     * Обработка успешного решения капчи
     */
    function handleCaptchaSuccess(token) {
        var errorDiv = document.getElementById('captcha-error');
        if (errorDiv) errorDiv.style.display = 'none';

        // Проверяем токен на бэкенде
        fetch('/api/verify-captcha', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ token: token })
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                // Все ок, скрываем модалку и вызываем колбэк (повторный поиск)
                hideCaptcha();
                if (typeof onVerifyCallback === 'function') {
                    onVerifyCallback();
                }
            } else {
                throw new Error(data.error || 'Verification failed');
            }
        })
        .catch(error => {
            console.error('[CAPTCHA] Error:', error);
            if (errorDiv) {
                errorDiv.textContent = 'Ошибка проверки. Пожалуйста, попробуйте еще раз.';
                errorDiv.style.display = 'block';
            }
            grecaptcha.reset(captchaWidgetId);
        });
    }

    function handleCaptchaExpired() {
        console.log('[CAPTCHA] Token expired');
    }

    function handleCaptchaError() {
        var errorDiv = document.getElementById('captcha-error');
        if (errorDiv) {
            errorDiv.textContent = 'Ошибка загрузки капчи. Проверьте соединение.';
            errorDiv.style.display = 'block';
        }
    }

    // Экспортируем в глобальную область
    window.CAPTCHA_HANDLER = {
        showCaptcha: showCaptcha,
        hideCaptcha: hideCaptcha
    };

})();



